(function(window, angular, undefined) {
    angular.module('formApp')
    .directive("postcodeFormat", [function() {
        return {
            restrict: "A",
            require:'ngModel',
            link: function($scope, element,ctrl,ngModel) {
                ngModel.$parsers.push(function (value) {
                    // Covert to uppercase and remove all whitespace
                    var transVal = value.toUpperCase().replace(/\s+/g, '');
                    // gives us the last 3 characters
                    var end = transVal.slice(-3);
                    //Gives us the rest 
                    var start = transVal.slice(0, -3);
                    //Joim them together and return with a space in the middle
                    var pc = start+" "+end;
                    return pc;
                });
            }
        };
    }]);
})(window, window.angular);